import { localeForLang } from "../i18n";

export function padIndex(index: number) {
	return String(index).padStart(2, "0");
}

export function formatDate(iso: string, lang: string) {
	const date = new Date(`${iso}T00:00:00`);
	if (Number.isNaN(date.getTime())) {
		return iso;
	}

	return date.toLocaleDateString(localeForLang(lang), {
		month: "short",
		day: "numeric",
		year: "numeric",
	});
}

export function formatMonth(iso: string, lang: string) {
	const date = new Date(`${iso}T00:00:00`);
	if (Number.isNaN(date.getTime())) {
		return iso;
	}

	return date.toLocaleDateString(localeForLang(lang), {
		month: "long",
		year: "numeric",
	});
}
